import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { getHostName } from '@jepto/shared/utils/hostname';
import { SHA512 } from 'crypto-js';
import { environment } from '@jepto/environments/environment';
import { fetchAuthSession } from 'aws-amplify/auth';


interface tokens {
    idToken: string;
    accessToken: string;
}

@Injectable({ providedIn: 'root' })
export class JepCookiesService {

    constructor(private cookieService: CookieService) { }

    setCookie(name: string, value: string) {
        const gn = getHostName();
        let domain: string = 'localhost';
        let isSecure: boolean = false;
        const expiredDate = new Date();
        expiredDate.setHours(expiredDate.getHours() + 1);
        if (environment.production === true || environment.staging === true || environment.develop === true) {
            domain = (gn.hostName === 'localhost') ? 'localhost' : `${environment.key === "prd" ? 'app' : environment.key}.jepto.com`
            isSecure = true;
        }
        this.cookieService.set(name, value, expiredDate, '/', domain, isSecure);
    }

    getCookieDetails(name: string): string {
        return this.cookieService.get(name);
    }

    deleteCookieDetails(name: string) {
        const gn = getHostName();
        let domain: string = 'localhost';
        let isSecure: boolean = false;
        const expiredDate = new Date();
        expiredDate.setHours(expiredDate.getHours() + 1);
        if (environment.production === true || environment.staging === true || environment.develop === true) {
            domain = (gn.hostName === 'localhost') ? 'localhost' : `${environment.key === "prd" ? 'app' : environment.key}.jepto.com`
            isSecure = true;
        }
        this.cookieService.delete(name, "/", domain, isSecure, "None");
    }

    getCookie(): tokens {
        const lastAuthUserCookie: string = this.getCookieDetails(`CognitoIdentityServiceProvider.${environment.cognitoSettings.ClientId}.LastAuthUser`);
        const idTokenName: string = `CognitoIdentityServiceProvider.${environment.cognitoSettings.ClientId}.${lastAuthUserCookie}.idToken`;
        const accessTokenName: string = `CognitoIdentityServiceProvider.${environment.cognitoSettings.ClientId}.${lastAuthUserCookie}.accessToken`;
        return {
            idToken: this.getCookieDetails(idTokenName),
            accessToken: this.getCookieDetails(accessTokenName)
        }
    }

    deleteCookie() {
        let tokenName: string = SHA512('jepto_sessionID').toString();
        return this.cookieService.delete(tokenName);
    }

    getAll() {
        return this.cookieService.getAll();
    }
}
